import { createFileRoute, useParams } from "@tanstack/react-router"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"
import { useStudentProgressQuery } from "@/api/queries/students/useStudentProgressQuery"
import { StudentProgressDetailPage } from "toptaal-shared"
import { useStudentSuspenseQuery } from "@/api/queries/students/useStudentSuspenseQuery"
import { useStudentCurrentInterruptionQuery } from "@/api/queries/students/useStudentCurrentInterruptionQuery"

export const Route = createFileRoute("/beheer/cursisten/$studentId/voortgang/")(
  {
    component: RouteComponent,
    beforeLoad: () => checkOrganizationPermissions("read", "students"),
  },
)

function RouteComponent() {
  const { studentId } = useParams({
    from: "/beheer/cursisten/$studentId/voortgang/",
  })
  const { data } = useStudentProgressQuery(Number(studentId))
  const {
    data: { data: student },
  } = useStudentSuspenseQuery(Number(studentId))
  const groups = data?.data.groups ?? []

  const { data: currentInterruption } = useStudentCurrentInterruptionQuery(
    student.currentStudentProjectOrganization?.id,
  )

  return (
    <StudentProgressDetailPage
      groups={groups}
      status={student.currentStudentProjectOrganization?.status}
      moduleCode={student.currentModule?.moduleCode}
      interruption={currentInterruption}
    />
  )
}
